import React, { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useWindowSize } from "../../hooks";

import store from "../../redux/store";
import * as Actions from "../../redux/actions";
import SearchContentInput from "../common/search-content-input";
import logoutImg from "../../../../assets/img/logout.png";

const GetMenuItem = ({
  menuType,
  catalogData,
  setMenuType,
  setOpenSearch,
  openSearch,
}) => {

  const type = menuType;
  return (
    <ul className="menuItem-container">

      {catalogData.map((element, i) => {
        return (
          <li key={i} className="menuItem">
            <NavLink
              onClick={() => {
                setOpenSearch(!openSearch), setMenuType("");
              }}
              to={`${type}/${element.code}`}
            >
              {element.name.toUpperCase()}
              <div className="underLine" />
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
};

const SearchPanel = ({ openSearch, setOpenSearch }) => {
  const [menuType, setMenuType] = useState("");

  const size = useWindowSize();

  const catalogData = useSelector((state) => state.catalog.catalogData);

  const catalogs = useSelector((state) => state.catalogs.catalogs);
  const categories = useSelector((state) => state.categories.categories);
  const marca = useSelector((state) => state.marcas.marcas);

  const marcas = "marcas";
  const catalogo = "catalogos";
  const categoria = "categorias";

  const logout = () => {

    store.dispatch(Actions.logout()).then(res => {

      if (res.type === Actions.USER_LOGEDOUT) {
        store.dispatch(Actions.confirmAuth(false))
    
    } else {
        store.dispatch(Actions.confirmAuth(true))
    }

    })

  }

  return (
    <div
      className={`search-container ${
        openSearch ? "searchOpen" : "searchClose"
      }`}
    >
      {openSearch && (
        <>
          <div className="top-bar">
            <div className="logout-btn" onClick={()=> logout()}>
              <img src={logoutImg}></img>
              <span>Logout</span>
            </div>
            <div
              className="closeButton"
              onClick={() => {
                setOpenSearch(!openSearch), setMenuType("");
              }}
            >
              <div className="closeButtonElements">
                <div className="line lineTop"></div>
                <div className="line lineBottom"></div>
              </div>
            </div>
          </div>

          <div className="search-content">
            <SearchContentInput
              setOpenSearch={setOpenSearch}
              openSearch={openSearch}
            />
            {size.width <= 428 ? (
              <div className="options">
                <div className="option">
                  <div
                    className="title"
                    onClick={(e) =>
                      menuType === e.target.id
                        ? setMenuType("")
                        : setMenuType(e.target.id)
                    }
                  >
                    <div
                      className={`${
                        menuType === "marcas" ? "icon rotate" : "icon"
                      }`}
                    ></div>
                    <span id="marcas">Por marcas</span>
                  </div>
                  <div className="menu">
                    {menuType === "marcas" ? (
                      <GetMenuItem
                        menuType={marcas}
                        catalogData={marca}
                        setMenuType={setMenuType}
                        setOpenSearch={setOpenSearch}
                        openSearch={openSearch}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="horizontal-line" />
                </div>
                <div className="option">
                  <div
                    className="title"
                    onClick={(e) =>
                      menuType === e.target.id
                        ? setMenuType("")
                        : setMenuType(e.target.id)
                    }
                  >
                    <div
                      className={`${
                        menuType === "catalogos" ? "icon rotate" : "icon"
                      }`}
                    ></div>
                    <span id="catalogos">Por catálogo</span>
                  </div>
                  <div className="menu">
                    {menuType === "catalogos" ? (
                      <GetMenuItem
                        menuType={catalogo}
                        catalogData={catalogs}
                        setMenuType={setMenuType}
                        setOpenSearch={setOpenSearch}
                        openSearch={openSearch}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="horizontal-line" />
                </div>
                <div className="option">
                  <div
                    className="title"
                    onClick={(e) =>
                      menuType === e.target.id
                        ? setMenuType("")
                        : setMenuType(e.target.id)
                    }
                  >
                    <div
                      className={`${
                        menuType === "categorias" ? "icon rotate" : "icon"
                      }`}
                    ></div>
                    <span id="categorias">Por categoría</span>
                  </div>
                  <div className="menu">
                    {menuType === "categorias" ? (
                      <GetMenuItem
                        menuType={categoria}
                        catalogData={categories}
                        setMenuType={setMenuType}
                        setOpenSearch={setOpenSearch}
                        openSearch={openSearch}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="horizontal-line" />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchPanel;
